import cssSides, { Side } from '@team-griffin/css-sides';
import { gu2px, Theme } from '@uds/theme-utils';
import longhand from '@team-griffin/css-longhand';
import { useStyles } from '@team-griffin/stylr';
import { useBreakpoints } from '@ux/responsive';

export default ({ theme: { spacing, palette, curvature } }: { theme: Theme }) => {
  const { isMinLg } = useBreakpoints();
  return useStyles(
    {
      default: {
        table: {
          backgroundColor: '#fff',
          color: palette.grey02,
        },

        theadRow: {
          display: 'flex',
          ...cssSides('padding', Side.Y, gu2px(3, spacing)),
          ...longhand('borderBottom', {
            width: 3,
            color: palette.secondary,
            style: 'solid',
          }),
        },

        cell: {
          flex: 1,
          flexBasis: 0,
        },

        tCellCenter: {
          textAlign: 'center',
        },
      },

      isMinLg: {
        theadRow: {
          paddingTop: gu2px(4, spacing),
        },
      },
    },
    [{ isMinLg }, { curvature }],
  );
};
